import { sfOr } from 'spring-filter-query-builder';
import { NdcReadDTO } from '../../api/dto';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const makeNdcFilter = (searchParam: string): string => {
    const likeQuery = `${escapeSfqbString(searchParam, true)}*`;
    return sfOr(
        (['ndcNumber', 'id'] satisfies (keyof NdcReadDTO)[]).map((field) => sfLike(field, likeQuery, true))
    ).toString();
};
